import React, { useEffect } from "react";
import { connect } from "react-redux";
import { notification } from "antd";
import { closeNotification } from "redux/notification.slice";

function Notifications({
  notification: { type, message } = {},
  closeNotification,
}) {
  useEffect(() => {
    function onClose() {
      closeNotification();
    }

    if (type && message) {
      notification[type]({
        message: message,
        onClose: onClose,
      });
    }
  }, [type, message, closeNotification]);

  return <></>;
}

const mapStateToProps = ({ notification }) => ({
  notification,
});

export default connect(mapStateToProps, { closeNotification })(Notifications);
